import styled from '@emotion/styled';
import { mediaQuery, responsiveFontSize } from '@presentation/styles';
import { Link } from 'react-router-dom';

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Section = styled.div`
  margin-top: 20px;
`;

export const SectionTitle = styled.h2`
  ${responsiveFontSize(24, 1)};
  font-weight: 600;
  padding-bottom: 5px;
  border-bottom: 1px solid ${(props) => props.theme.color.light.shade};
`;

export const LinksContainer = styled.div`
  padding: 10px 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

export const StyledLink = styled(Link)`
  font-weight: 400;

  display: block;
  width: 33.3%;
  padding-right: 10px;
  margin-bottom: 5px;

  &:hover {
    text-decoration: underline;
  }
  ${mediaQuery('medium')} {
    width: 50%;
  }
  ${mediaQuery('phone')} {
    width: 100%;
  }
`;
